import { MEDIA_KIT_PDF } from 'src/common/constants';
import type { HeroGridCardProps } from '../HeroGridCard';

const cards: HeroGridCardProps[] = [
  {
    id: 0,
    cardType: 'details-card',
    iconId: 'category-center-console',
    iconColor: 'sunset',
    title: 'card--0--title',
    text: 'card--0--text',
  },
  {
    id: 1,
    cardType: 'image',
    image: {
      src: 'image--0',
      alt: 'image--0--altText',
      sizes: {
        xl: 378,
        s: 456,
        default: 335,
      },
    },
  },
  {
    id: 2,
    cardType: 'image',
    image: {
      src: 'image--1',
      alt: 'image--1--altText',
      sizes: {
        default: 378,
      },
    },
    visibleFrom: 'xl',
  },
  {
    id: 3,
    cardType: 'details-card',
    iconId: 'sail-boat',
    iconColor: 'sand',
    title: 'card--1--title',
    text: 'card--1--text',
  },
  {
    id: 4,
    cardType: 'image',
    image: {
      src: 'image--2',
      alt: 'image--2--altText',
      sizes: {
        xl: 378,
        s: 456,
        default: 335,
      },
    },
  },
  {
    id: 5,
    cardType: 'image',
    image: {
      src: 'image--3',
      alt: 'image--3--altText',
      sizes: {
        xl: 378,
        m: 720,
        default: 335,
      },
    },
    gridColumnSpanStart: 'm',
    gridColumnSpanEnd: 'xl',
  },
  {
    id: 6,
    cardType: 'details-card',
    iconId: 'wave',
    iconColor: 'bluminescence-01',
    title: 'card--2--title',
    text: 'card--2--text',
  },
  {
    id: 7,
    cardType: 'image',
    image: {
      src: 'image--4',
      alt: 'image--4--altText',
      sizes: {
        xl: 790,
        s: 456,
        default: 335,
      },
    },
    gridColumnSpanStart: 'xl',
  },
  {
    id: 8,
    cardType: 'details-card',
    cardBackground: 'midnight-02',
    iconId: 'globe',
    iconColor: 'midnight-01',
    title: 'card--3--title',
    text: 'card--3--text',
    linkText: 'card--3--linkText',
    linkIconId: 'arrow-right',
    linkHref: 'https://getmyboat.breezy.hr/',
  },
  {
    id: 9,
    cardType: 'image',
    image: {
      src: 'image--5',
      alt: 'image--5--altText',
      sizes: {
        xl: 378,
        s: 456,
        default: 335,
      },
    },
    visibleFrom: 'xl',
  },
  {
    id: 10,
    cardType: 'image',
    image: {
      src: 'image--6',
      alt: 'image--6--altText',
      sizes: {
        default: 378,
      },
    },
  },
  {
    id: 11,
    cardType: 'logo-card',
    cardBackground: 'midnight-01',
    image: {
      src: 'about/gmb-logo.svg',
      alt: 'card--6--altText',
      width: 180,
      height: 144,
    },
    gridColumnSpanStart: 'm',
    gridColumnSpanEnd: 'xl',
  },
  {
    id: 12,
    cardType: 'details-card',
    cardBackground: 'bluminescence-02',
    iconId: 'speedboat',
    iconColor: 'midnight-01',
    title: 'card--4--title',
    text: 'card--4--text',
    linkText: 'card--4--linkText',
    linkIconId: 'cloud-arrow-down',
    linkHref: MEDIA_KIT_PDF,
  },
  {
    id: 13,
    cardType: 'details-card',
    cardBackground: 'bluminescence-02',
    title: 'card--5--title',
    text: 'card--5--text',
  },
  {
    id: 14,
    cardType: 'image',
    image: {
      src: 'image--7',
      alt: 'image--7--altText',
      sizes: {
        xl: 378,
        m: 720,
        default: 335,
      },
    },
    gridColumnSpanStart: 'm',
    gridColumnSpanEnd: 'xl',
  },
  {
    id: 15,
    cardType: 'logo-card',
    image: {
      src: 'yanmar-logo-red.svg',
      alt: 'card--7--altText',
      width: 197,
      height: 109,
    },
    title: 'card--7--title',
    text: 'card--7--text',
    linkText: 'card--7--linkText',
    linkIconId: 'arrow-right',
    linkHref: 'https://www.yanmar.com/marine/about-us/yanmar-marine-international/news/yanmar-announces-strategic-investment-in-getmyboat/',
  },
  {
    id: 16,
    cardType: 'image',
    image: {
      src: 'image--8',
      alt: 'image--8--altText',
      sizes: {
        xl: 378,
        s: 456,
        default: 335,
      },
    },
  },
];

export default cards;
